import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportResponse } from 'app/report/models/report-response.model';
import { ReportService } from 'app/report/services/report.service';
import { RoutingService } from 'app/routing/services/routing.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-simple-report-list',
  templateUrl: './simple-report-list.component.html',
  styleUrls: ['../../../scss/dashboard.components.scss', './simple-report-list.component.scss']
})
export class SimpleReportListComponent implements OnInit, OnDestroy {
    projectListSubscription: Subscription;
    projects: ReportResponse[] = [];
    projectsHaveLoaded: boolean;

    constructor(private reportService: ReportService, private routingService: RoutingService) {}

    ngOnInit() {
      this.projectListSubscription = this.reportService.onProjectListUpdate.subscribe(
        (reportList) => {
          this.projectsHaveLoaded = true;
          this.projects = reportList.filter((r) => !r.report.isDeleted);
        },
        (error) => console.log(error)
      );
      this.reportService.getLatestReports();
      this.reportService.updateReportProgressFromService();
    }

    ngOnDestroy() {
      this.projectListSubscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/components/recent-reports/list/simple-report-list.component.ts